import { render, staticRenderFns } from "./diasLaborales.vue?vue&type=template&id=921223b6&scoped=true"
import script from "./diasLaborales.vue?vue&type=script&lang=js"
export * from "./diasLaborales.vue?vue&type=script&lang=js"
import style0 from "./diasLaborales.vue?vue&type=style&index=0&id=921223b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "921223b6",
  null
  
)

export default component.exports